export const breadcrumb = {
  title: 'Виртуальная АТС',

  number: {
    index: 'Номера АТС'
  },

  media: {
    index: 'Медиа файлы'
  },

  operator: {
    index: 'Операторы'
  },

  group: {
    index: 'Группы',
    create: 'Добавить группу',
    edit: 'Редактировать группу'
  },

  contact: {
    index: 'Контакты',
    create: 'Добавить контакт',
    edit: 'Редактировать контакт'
  },

  'sip-account': {
    index: 'SIP-аккаунты',
    create: 'Добавить SIP-аккаунт'
  },

  'service-package': {
    index: 'Пакеты услуг'
  },

  'phone-list': {
    index: 'Списки номеров',
    create: 'Добавить список номеров',
    edit: 'Редактировать список номеров'
  },

  'time-condition': {
    index: 'Расписания',
    create: 'Добавить расписание',
    edit: 'Редактировать расписание'
  },

  worksheet: {
    index: 'Маршрутизация звонков',
    create: 'Добавить схему'
  },
  setting: {
    index: 'Настройки АТС'
  }
};
